var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CardWrapper",
    {
      staticClass: "wallet-widget",
      attrs: { "data-test-id": "wallet-widget", title: _vm.i18n.dash_wallet() }
    },
    [
      _c("div", { staticClass: "wallet-widget__balance" }, [
        _c("p", { attrs: { "data-test-id": "wallet-widget-common-balance" } }, [
          _vm._v("\n      " + _vm._s(_vm.tronSum) + " "),
          _c("span", { staticClass: "currency" }, [_vm._v("USDT/USDC")])
        ])
      ]),
      _vm._v(" "),
      _c("SwitchWrapper", {
        staticClass: "wallet-zero-switch",
        attrs: { label: _vm.i18n.lbl_zeros() },
        on: {
          switchChange: function($event) {
            _vm.hideZeroBalances = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wallet-widget__balances",
          attrs: { "data-test-id": "wallet-widget-balances-list" }
        },
        _vm._l(_vm.showedBalances, function(bl) {
          return _c(
            "div",
            {
              key: "balance-" + bl.key,
              class: [
                "wallet-widget__balances-item",
                { active: _vm.activeBalance === bl.key }
              ],
              attrs: {
                "data-test-id": "wallet-widget-balances-item-" + bl.key
              },
              on: {
                click: function($event) {
                  return _vm.toggleBalance(bl.key)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "wallet-widget__balances-item-header" },
                [
                  _c(
                    "p",
                    {
                      staticClass: "text_medium",
                      attrs: {
                        "data-test-id": "wallet-widget-balances-item-coin"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(bl.formated) + "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "text_medium amount",
                      attrs: {
                        "data-test-id": "wallet-widget-balances-item-amount"
                      }
                    },
                    [_vm._v("\n          " + _vm._s(bl.balance) + "\n        ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c("AccordeonWrapper", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeBalance === bl.key,
                        expression: "activeBalance === bl.key"
                      }
                    ],
                    staticClass: "wallet-widget__balances-item-details",
                    attrs: {
                      "data-test-id": "wallet-widget-balances-item-details"
                    }
                  },
                  [
                    _c(
                      "p",
                      {
                        attrs: {
                          "data-test-id": "wallet-widget-balances-item-white"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.i18n.white_wallet()) +
                            "\n            "
                        ),
                        _c(
                          "span",
                          {
                            attrs: {
                              "data-test-id":
                                "wallet-widget-balances-item-white-amount"
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.balance) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        attrs: {
                          "data-test-id": "wallet-widget-balances-item-gray"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.i18n.gray_wallet()) +
                            "\n            "
                        ),
                        _c(
                          "span",
                          {
                            attrs: {
                              "data-test-id":
                                "wallet-widget-balances-item-gray-amount"
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.greyTronValue) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wallet-widget__btn-container",
          attrs: { "data-test-id": "wallet-widget-btn-container" }
        },
        [
          _c("RoundButton", {
            attrs: {
              label: _vm.i18n.lbl_refill(),
              disabled: _vm.isDisabledTransferableBtn,
              testId: "wallet-widget-top-up-btn",
              icon: "/static/img/banknote-arrow-up.svg"
            },
            on: {
              click: function($event) {
                return _vm.$emit(_vm.events.walletTopUp, _vm.currentAsset)
              }
            }
          }),
          _vm._v(" "),
          _c("RoundButton", {
            attrs: {
              label: _vm.i18n.lbl_withdraw(),
              disabled: _vm.isDisabledTransferableBtn || !_vm.isShowWithdrawal,
              testId: "wallet-widget-withdrawal-btn",
              icon: "/static/img/banknote-arrow-down.svg"
            },
            on: {
              click: function($event) {
                return _vm.$emit(
                  _vm.events.withdrawalFromWallet,
                  _vm.currentAsset
                )
              }
            }
          }),
          _vm._v(" "),
          _c("RoundButton", {
            attrs: {
              label: _vm.i18n.lbl_exchange(),
              disabled: true,
              testId: "wallet-widget-exchange-btn",
              icon: "/static/img/arrow-right-left.svg"
            }
          }),
          _vm._v(" "),
          _c("RoundButton", {
            attrs: {
              label: _vm.i18n.lbl_update(),
              disabled: _vm.isLoading,
              testId: "wallet-widget-refresh-btn",
              icon: "autorenew"
            },
            on: { click: _vm.refreshWallet }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44d78fb0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44d78fb0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/widgets/WalletWidget.vue
// module id = mPkM
// module chunks = 1